<div [ngClass]="{'content': !signupForm , 'content-new': signupForm , 'content-searchtool': searchtoolScreen,'content-pt0':routeCheckForScrollNavabar , 'h-100': !signupForm, 'content-webbtree-freemium':removeContentPadding, 'content-webbtree-freemium2':removeContentPaddingFreeTrial}">
  <div class="container-fluid h-100 px-0" *ngIf="loadApplication">
    <div class="row h-100" [ngClass]="{'mx-0': signupForm }">
      <div class="col"  [ngClass]="{'px-0': signupForm }">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<!-- *ngIf="totalGrabbedCandidate" -->
<div class="position-fixed pointer" style="bottom: 0; right: 0;"  *ngIf="totalGrabbedCandidate > 0">
  <div style="width: 320px;margin-left: auto;box-shadow: 0 2px 4px 0 rgb(221 221 221 / 50%), 0 2px 4px 0 rgb(0 0 0 / 50%);">
    <p class="py-2 mb-0 pl-2" style="background-color: #04363d;color: #fff;"> 
      Grabbing {{totalGrabbedCandidate}} Candidate
    </p>
    <div class="d-flex justify-content-between py-3 px-2 mb-0"  
    style="background-color: #fff; ">
    <span>
      <i class="fas fa-users mr-2" style="color: #04363d;"> </i>{{totalGrabbedCandidate}} Candidate
    </span>
    <span style="color: #04363d;" class="mr-2">
      In progress...
    </span>
    </div>
  </div>
</div>
  <app-loading-screen class="loading-screen"></app-loading-screen> 
